import _ from 'lodash';
import React, { PureComponent } from 'react';
import ExpandToggleButton from '../../../../treeComponents/component/ExpandToggleButton';
import { defaultDisplaySetting } from '../../../../treeComponents/component/helpers/preSelectedFilters';
import { getFormattedDates } from '../../../../treeComponents/helper';

interface WeekNodeProps {
  data: any;
  handleExpandNode: Function;
  isExpanded: boolean;
  subjectTab: string;
  viewPlanData:any;
}
const bullets = {
  color: '#C4C4C4',
  padding: '0px 10px',
  marginTop: '5px',
};
const subjectNameStyles = {
  fontSize: '20px',
};
class WeekNode extends PureComponent<WeekNodeProps> {
  getConceptCount = () => {
    let conceptCount = 0;
    const {viewPlanData}=this.props;
    const showChapters=_.get(viewPlanData,'displaySettings.showChapters',true);
    if (this.props.subjectTab === 'All Subjects') {
      try {
        if(showChapters){
         this.props.data.children.forEach((chapter: any) => 
             conceptCount += chapter.concepts.length);
        }else{
          conceptCount=this.props.data.children.length;
        }
      } catch (error) {}
    } else {
      try {
        this.props.data.children.forEach((chapter: any) => {
          if (this.props.subjectTab === chapter.subjectName) {
            if(showChapters){
              conceptCount += chapter.concepts.length;
            }else{
              conceptCount+=1;
            }
          }
        });
      } catch (error) {}
    }
    return conceptCount;
  };

  render = () => {
    const { data, handleExpandNode, isExpanded,viewPlanData } = this.props;
    const { name = '', startDate, endDate, children, content } = data;
    const hasValidChildren = (children && children.length) || (content && content.length > 0);
    const displaySettings=_.get(viewPlanData,"displaySettings",defaultDisplaySetting);
    return (
      <span style={{ minHeight: '5vh' }}>
        <div>
        <span
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
          {hasValidChildren ? (
            <ExpandToggleButton handleClick={handleExpandNode} isExpanded={isExpanded} />
          ) : (
            <></>
          )}
          <span style={subjectNameStyles}>
            {name}
            <span
              style={{
                color: '#666',
                fontSize: '16px',
                // marginLeft: '1%',
              }}
            >
              <span style={bullets}>&bull;</span>
              {getFormattedDates(startDate, endDate)}
            </span>
            <span
              style={{
                color: '#666',
                fontSize: '16px',
                // marginLeft: '1%',
              }}
            >
              </span>
              <span style={bullets}>&bull;</span>
              </span>
              {displaySettings.showConcepts ? <span>{this.getConceptCount()} Concepts</span>: ''}
          </span>
        </div>
      </span>
    );
  };
}

export default WeekNode;
